import React from 'react';
import MissionDetail from './MissionDetail';
import missionsData from '../data/missions.json';

function MissionSpiritualUpliftment() {
  return <MissionDetail mission={missionsData.spiritualUpliftment} />;
}

export default MissionSpiritualUpliftment;
